module.exports = __webpack_public_path__ + "img/station-array-unhealthy.31b73697.png";